(() => {
  if (customElements.get('ds-no-show-picker')) return;
  customElements.whenDefined('ds-core-set-picker').then(() => {
    customElements.define('ds-no-show-picker', class extends customElements.get('ds-core-set-picker') {
      connectedCallback() {
        if (this.ready) { this.setupFloatingCart(); return; }
        this.sizes = JSON.parse(this.querySelector('[data-size-catalog]').textContent);
        this.size = this.dataset.initialSize;
        super.connectedCallback();
        this.querySelectorAll('[name="ds_size"]').forEach(input => input.addEventListener('change', () => {
          this.size = input.value;
          this.render();
          const url = new URL(location.href);
          const pageProduct = this.catalog[this.dataset.bundlePage === 'true' ? 'core' : 'single'];
          url.searchParams.set('variant', pageProduct.id);
          history.replaceState(history.state, '', url);
        }));
        this.querySelector('[data-size-fit]').addEventListener('click', () => {
          const section = this.closest('product-info');
          const details = section.querySelector('details[id*="collapsible_tab_FUad3Y"]');
          if (!details) return;
          details.open = true;
          details.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          details.querySelector('summary')?.focus({preventScroll:true});
        });
        this.dataset.ready = 'true';
        this.setupFloatingCart();
      }
      setupFloatingCart() {
        if (this.floatingCart) return;
        const bar = document.createElement('div');
        bar.className = 'ds-no-show-floating';
        bar.hidden = true;
        bar.setAttribute('role', 'region');
        bar.setAttribute('aria-label', this.t('choose_purchase'));
        bar.innerHTML = '<div class="ds-no-show-floating__inner"><a class="ds-no-show-floating__selection"><strong></strong><span></span></a><div class="ds-no-show-floating__price"><strong></strong><small></small></div><button type="button" class="ds-no-show-floating__add"></button></div>';
        this.floatingCart = bar;
        const selection = bar.querySelector('a');
        selection.href = '#' + this.id;
        selection.addEventListener('click', event => {
          event.preventDefault();
          this.reviewFloatingSelection(this.querySelector('[name="ds_size"]:checked'));
        });
        bar.querySelector('button').addEventListener('click', () => {
          const {ready, recurring, plan, product} = this.state();
          if (this.pending || !product.available) return;
          if (!ready) {
            this.reviewFloatingSelection(recurring && !plan ? this.el('interval') : this.querySelector('[name="ds_purchase"]'));
          } else if (!this.el('add').disabled) {
            this.form.requestSubmit(this.el('add'));
          }
        });
        document.body.append(bar);
        this.floatingScroll = () => {
          if (this.floatingFrame) return;
          this.floatingFrame = requestAnimationFrame(() => {
            this.floatingFrame = null;
            const add = this.el('add');
            bar.hidden = !add.getClientRects().length || add.getBoundingClientRect().bottom > 0;
            document.body.classList.toggle('ds-no-show-floating-open', !bar.hidden);
          });
        };
        window.addEventListener('scroll', this.floatingScroll, {passive: true});
        window.addEventListener('resize', this.floatingScroll, {passive: true});
        this.floatingResize = new ResizeObserver(() => {
          if (!bar.hidden) document.body.style.setProperty('--ds-no-show-floating-height', bar.getBoundingClientRect().height + 'px');
          this.floatingScroll();
        });
        this.floatingResize.observe(bar);
        this.floatingResize.observe(this.form);
        this.floatingMutation = new MutationObserver(() => this.syncFloatingCart());
        this.floatingMutation.observe(this.el('add'), {attributes: true, childList: true, subtree: true});
        this.syncFloatingCart();
      }
      reviewFloatingSelection(target) {
        target?.scrollIntoView({block: 'center', behavior: 'instant'});
        target?.focus({preventScroll: true});
      }
      syncFloatingCart() {
        const bar = this.floatingCart;
        if (!bar) return;
        const {product, recurring, plan, ready} = this.state();
        const selection = bar.querySelector('a');
        selection.querySelector('strong').textContent = this.set === 'core' ? this.t('core') : product.title;
        selection.querySelector('span').textContent = this.size + ' · ' + (recurring ? (plan ? this.cadenceLabel(plan.cadence) : this.t('choose_interval')) : this.t('one_time'));
        selection.setAttribute('aria-label', selection.querySelector('strong').textContent + '. ' + selection.querySelector('span').textContent + '. ' + this.t('choose_purchase'));
        bar.querySelector('.ds-no-show-floating__price strong').textContent = this.el('total').textContent;
        bar.querySelector('.ds-no-show-floating__price small').textContent = this.el('total-unit').textContent;
        const button = bar.querySelector('button');
        button.textContent = this.pending ? this.t('adding') : !product.available ? this.t('sold_out') : !this.purchase ? this.t('choose_purchase') : !ready ? this.t('sticky_choose_interval') : this.t(recurring ? 'add_recurring' : 'add');
        button.disabled = this.pending || !product.available || (ready && this.el('add').disabled);
        button.setAttribute('aria-label', button.textContent + '. ' + this.el('add').getAttribute('aria-label'));
        bar.setAttribute('aria-busy', String(this.pending));
        this.floatingScroll();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.floatingScroll);
        window.removeEventListener('resize', this.floatingScroll);
        cancelAnimationFrame(this.floatingFrame);
        this.floatingFrame = null;
        this.floatingMutation?.disconnect();
        this.floatingResize?.disconnect();
        this.floatingCart?.remove();
        this.floatingCart = null;
        document.body.classList.remove('ds-no-show-floating-open');
        document.body.style.removeProperty('--ds-no-show-floating-height');
      }
      render() {
        // Select by the size name, never variant order or first available size.
        this.catalog = this.sizes[this.size];
        super.render();
        const section = this.closest('product-info');
        const preview = ['unpublished', 'development'].includes(window.Shopify?.theme?.role)
          ? String(window.Shopify.theme.id) : null;
        section.querySelectorAll('[data-ds-set-colors] a').forEach(link => {
          const variants = Object.fromEntries(link.dataset.sizeVariants.split('|').map(pair => pair.split(':')));
          const url = new URL(link.href);
          if (variants[this.size]) url.searchParams.set('variant', variants[this.size]);
          if (preview) url.searchParams.set('preview_theme_id', preview);
          else url.searchParams.delete('preview_theme_id');
          link.href = url.href;
        });
        const cartLink = this.el('cart-link');
        const cartURL = new URL(cartLink.href);
        if (preview) cartURL.searchParams.set('preview_theme_id', preview);
        else cartURL.searchParams.delete('preview_theme_id');
        cartLink.href = cartURL.href;
        const summary = this.el('selected-copy');
        summary.textContent += ' · ' + this.size;
        const add = this.el('add');
        add.setAttribute('aria-label', add.getAttribute('aria-label') + '. ' + this.size);
        this.syncFloatingCart();
      }
    });
  });
})();
